
import React from 'react';

// Monthly plan features
export const featuresMonthly = [
  'Unlimited track uploads',
  'Unlimited fan downloads',
  'Insights & analytics dashboard',
  'Priority support',
  'Access to all future updates'
];

// Annual plan features
export const featuresAnnual = [
  'Unlimited track uploads',
  'Unlimited fan downloads',
  'Full analytics dashboard',
  'Priority support',
  'Future feature updates for life',
  'Early access to new features'
];

// Lifetime plan features
export const featuresLifetime = [
  'Unlimited fan downloads',
  'Full analytics & advanced insights',
  'Priority support',
  'All future feature updates for life',
  'Early access to new features',
  'Personal onboarding',
  'Spotify Growth Course'
];

export default {
  featuresMonthly,
  featuresAnnual,
  featuresLifetime
};
